import React from "react";
import { useTranslation } from "lib/i18n/use-translation";
import base from "../../styles/company.module.scss";
import styles from "./error-page.module.scss";

type PortalErrorPageProps = {
  pageTitle?: string;
};
const PortalErrorPage: React.FC<PortalErrorPageProps> = ({ pageTitle }) => {
  const { t } = useTranslation(["common"]);

  return (
    <div className={styles["error-container"]}>
      <div className={base["content"]}>
        <h1 className={base["main-title"]}>{pageTitle}</h1>
        <p>{t("common:error.message")}</p>
      </div>
    </div>
  );
};

export default PortalErrorPage;
